import React, { FunctionComponent } from 'react';
import TitleHeader from './TitleHeader';
import AddCTA from '../ShippingDetails/components/AddCTA';
import { SelectedAddressType } from '../ShippingMethod/ShippingMethod';
import FilterAddresses from '../ShippingMethod/components/FilterAddresses';
import { dispatch } from '@Redux/store';
import useTranslate from '@Utils/hooks/useTranslate';
import { modalTypes, setModal } from '@Redux/modules/modal/actions';
import { ShippingAddressWrapper, ContentContainer, ListContainer, Heading } from './ShippingAddress.styled';
import useAddressBook from '@Utils/hooks/useAddressBook';

const ShippingAddress: FunctionComponent<types.cards.IShippingAddressCardProps> = () => {
	const { translate } = useTranslate();
	const { addressBook } = useAddressBook();
	const closeModal = () => {
		dispatch(
			setModal({
				type: null,
				data: null,
			})
		);
	};
	const addNewAddress = () => {
		closeModal();
		dispatch(
			setModal({
				type: modalTypes.DELIVERY_ADDRESS,
				data: { type: 'shipmentAddress', action: 'create', skipMap: true },
				withoutContainer: true,
			})
		);
		return false;
	};

	return (
		<ShippingAddressWrapper>
			<TitleHeader title={translate(`shipping-address.title`)} />
			<ContentContainer>
				<ListContainer>
					<Heading>{translate('secure-checkout.select-address')}</Heading>
					<FilterAddresses
						addressBook={addressBook}
						addressType={SelectedAddressType.ADRESS_BOOK}
						filter={undefined}
					/>
					<AddCTA
						label={translate('secure-checkout.add-new-address')}
						onClick={addNewAddress}
						uniqueId="shippingAddress.addNewAddress"
					/>
				</ListContainer>
			</ContentContainer>
		</ShippingAddressWrapper>
	);
};

export default ShippingAddress;
